<template>
  <div class="dflexr-jcc" id="page-view">
    <div class="" id="prev-page" @click.stop="change_page('prev')">
      <unicon name="angle-left" fill="#017579"
              v-if="current_page > 0"
              width="128" height="256"
              class="btn btn-prev"
              hover-fill="cyan"/>
    </div>

    <component :is="pageViews[current_page]" />

    <div class="dflexc-jcc" id="next-page" @click.stop="change_page('next')">
      <unicon name="angle-right" fill="#017579"
              v-if="current_page < maxPage"
              width="128" height="256"
              class="btn btn-next"
              hover-fill="cyan"/>
    </div>

    <div class="return-to-empirewargames">
      <router-link class="nav-link" to="EmpireWargames">
        Return to Empire Wargames
      </router-link>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/styles/colors';
@import '@/assets/styles/global_variables';

.return-to-empirewargames {
  position: fixed;
  bottom: 15px;
  left: 10px;
  width: 150px;

  border: 3px outset $bg-drk20;
  border-top-left-radius: 8px;
  border-bottom-right-radius: 12px;
  padding: .2rem .5rem;
  margin-top: 5px;
  background-color: $bg-drk10;


  .nav-link {
    color: $bg-drk20;
    text-decoration: none;

    &:hover {
      color: $fg-base;
    }
  }

}

#prev-page,
#next-page {
  width: 128px;
}

#prev-page {
  position: fixed;
  top: 40%;
  left: 10px;
}

#next-page {
  position: fixed;
  top: 40%;
  right: 50px;
}

#page-view {
  width: 95%;
  margin: 0 auto;
}
</style>

<script setup>
import IronOFC from '../iron/iron_ofc_view.vue'
import IronIFC from '../iron/iron_ifc_view.vue'
import IhbookPageI from './ihbook_page_i.vue'
import IhbookPageII from './ihbook_page_ii.vue'

import IhbookPage01 from './ihbook_page01.vue'

import {ref} from "vue";

const current_page = ref(0)
const pageViews = ref([IronOFC, IronIFC, IhbookPageI, IhbookPageII, IhbookPage01])

if(get_ibkPage() !== null || get_ibkPage() !== undefined)
  current_page.value = get_ibkPage()
const maxPage = pageViews.value.length - 1

function get_ibkPage() {
  let pg = localStorage.getItem('ibk_page')
  if(pg === null || pg === undefined)
    pg = 0
  return JSON.parse(pg)
}

function set_ibkPage(pg) {
  localStorage.setItem('ibk_page', pg)
}
function change_page(val, event) {

  if(val === 'prev') {
    if(current_page.value > 0)
      current_page.value -= 1
  } else if(val === 'next') {
    if(current_page.value < maxPage)
      current_page.value += 1
  }
  console.log('current page:', current_page.value)

  set_ibkPage(current_page.value)
}

</script>
